import { Contribution, ContributionPublic } from '../../../../../common/model/input/contributions/types';
import { EntityWithContribution } from './types';

export interface SendContributionAction {
  type: 'CONTRIBUTION/SEND';
  payload: {
    contribution: {
      data: Contribution;
      target?: string;
    };
    requestId: string;
  };
}
export function sendContribution(
  contribution: {
    data: Contribution;
    target?: string;
  },
  requestId: string,
): SendContributionAction {
  return {
    type: 'CONTRIBUTION/SEND',
    payload: {
      contribution,
      requestId,
    },
  };
}

interface StoreContributionsAction {
  type: 'CONTRIBUTION/STORE';
  payload: {
    contributions: ContributionPublic[];
  };
}
export function storeContributions(contributions: ContributionPublic[]): StoreContributionsAction {
  return {
    type: 'CONTRIBUTION/STORE',
    payload: {
      contributions,
    },
  };
}

interface AppendEntityContributionsAction {
  type: 'CONTRIBUTION/APPEND_FOR_ENTITY';
  payload: {
    type: EntityWithContribution;
    id: string;
    contributions: number[];
  };
}
export function appendEntityContributions(
  type: EntityWithContribution,
  id: string,
  contributions: number[],
): AppendEntityContributionsAction {
  return {
    type: 'CONTRIBUTION/APPEND_FOR_ENTITY',
    payload: {
      type,
      id,
      contributions,
    },
  };
}

interface AppendLatestContributionsAction {
  type: 'CONTRIBUTION/APPEND_LATEST';
  payload: {
    contributions: number[];
  };
}
export function appendLatestContributions(contributions: number[]): AppendLatestContributionsAction {
  return {
    type: 'CONTRIBUTION/APPEND_LATEST',
    payload: {
      contributions,
    },
  };
}

export type ContributionAction =
  | SendContributionAction
  | AppendEntityContributionsAction
  | AppendLatestContributionsAction
  | StoreContributionsAction;
